import { render } from "./ProfileNotifications.vue?vue&type=template&id=d472da50&scoped=true&lang=pug"
import script from "./ProfileNotifications.vue?vue&type=script&lang=js"
export * from "./ProfileNotifications.vue?vue&type=script&lang=js"

import "./ProfileNotifications.vue?vue&type=style&index=0&id=d472da50&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d472da50"]])

export default __exports__